/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect } from 'react';
import { Box } from 'pcln-design-system';
import ChatMessageErrorBoundary from '../../ErrorBoundary/ChatMessageErrorBoundary';
import { HotelDetailCardsMessage } from '../../../HotelComponent/HotelDetailCard';
import Trips from '../../Trips/Trips';
import { ChatbotDataContext } from '../../../context/ChatbotDataContext';
const RenderMarkers = ({
  markerToDisplay,
  setMarker
}) => {
  var _a, _b, _c, _d, _e;
  const {
    isMobile
  } = useContext(ChatbotDataContext);
  useEffect(() => {
    var _a;
    if (((_a = markerToDisplay === null || markerToDisplay === void 0 ? void 0 : markerToDisplay.markerItem) === null || _a === void 0 ? void 0 : _a.displayComponentName) === 'REALTIME_HOTEL_BOOKING_MARKER') {
      setMarker(null);
    }
  }, [markerToDisplay]);
  if (((_a = markerToDisplay === null || markerToDisplay === void 0 ? void 0 : markerToDisplay.markerItem) === null || _a === void 0 ? void 0 : _a.displayComponentName) === 'DISPLAY_MY_TRIPS') {
    const {
      tripsList: trips,
      hasMoreTrips,
      deepLinkPrompt,
      tripHeaderMsg
    } = markerToDisplay.markerItem.componentProps || {};
    return React.createElement(Box, {
      key: `chat-msg-display-my-trips-marker`,
      px: 2,
      py: 4
    }, React.createElement(ChatMessageErrorBoundary, {
      compnentName: 'Trips-realtime'
    }, React.createElement(Trips, {
      trips: trips,
      deepLinkPrompt: deepLinkPrompt,
      tripHeaderMsg: tripHeaderMsg,
      hasMoreTrips: hasMoreTrips,
      displayInRealtimeVoice: true
    })));
  }
  if (((_b = markerToDisplay === null || markerToDisplay === void 0 ? void 0 : markerToDisplay.markerItem) === null || _b === void 0 ? void 0 : _b.displayComponentName) === 'REALTIME_HOTEL_BOOKING_MARKER') {
    window.open((_d = (_c = markerToDisplay === null || markerToDisplay === void 0 ? void 0 : markerToDisplay.markerItem) === null || _c === void 0 ? void 0 : _c.componentProps) === null || _d === void 0 ? void 0 : _d.checkoutLink, '_blank');
  }
  return React.createElement(Box, null, ((_e = markerToDisplay === null || markerToDisplay === void 0 ? void 0 : markerToDisplay.markerItem) === null || _e === void 0 ? void 0 : _e.displayComponentName) === 'HOTEL_CARDS_MARKER' ? React.createElement(Box, {
    key: `chat-msg-hotel-cards-marker`,
    px: 2,
    py: '60px'
  }, React.createElement(ChatMessageErrorBoundary, {
    compnentName: 'HotelDetailCardsMessage-realtime'
  }, React.createElement(HotelDetailCardsMessage, Object.assign({}, markerToDisplay === null || markerToDisplay === void 0 ? void 0 : markerToDisplay.markerItem.componentProps, {
    date: new Date(),
    setChatMessages: function () {},
    isMobile: isMobile,
    isShowMoreListingCards: false
  })))) : null);
};
export default React.memo(RenderMarkers);